
class ZrpSelect {

    constructor(selectId) {

        this.select = document.getElementById(selectId);
        this.button = this.select.querySelector('.zrp-ps__button');
        this.optionsList = this.select.querySelector('.zrp-ps__options-list');
        this.options = this.select.querySelectorAll('[role="option"]');
        this.selectedValueSpan = this.select.querySelector('.zrp-ps__selected-value');
        this.announcer = document.getElementById('zrp-selection-announcer');
        
        this.currentIndex = -1;
        this.isOpen = false;
        
        this.init();
    }
    
    init() {

        this.button.addEventListener('click', () => {
            this.toggleDropdown();
        });
        this.button.addEventListener('keydown', (e) => this.handleButtonKeydown(e));
        
        this.options.forEach((option, index) => {
            option.addEventListener('click', () => this.selectOption(index));
            option.addEventListener('keydown', (e) => this.handleOptionKeydown(e, index));
            option.addEventListener('mouseenter', () => this.highlightOption(index));
        });
        
        document.addEventListener('click', (e) => {
            if (!this.select.contains(e.target)) {
                this.closeDropdown();
            }
        });
        
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.closeDropdown();
                this.button.focus();
            }
        });
        
    }
    
    toggleDropdown() {
        if (this.isOpen) {
            this.closeDropdown();
        } else {
            this.openDropdown();
        }
    }
    
    openDropdown() {
        this.isOpen = true;
        this.button.setAttribute('aria-expanded', 'true');
        this.optionsList.hidden = false;
        
        if (this.currentIndex >= 0) {
            this.options[this.currentIndex].focus();
        } else {
            this.options[0].focus();
            this.currentIndex = 0;
        }
        
        this.updateAriaSelected();
    }
    
    closeDropdown() {
        this.isOpen = false;
        this.button.setAttribute('aria-expanded', 'false');
        this.optionsList.hidden = true;
        
        this.options.forEach(option => {
            option.setAttribute('aria-selected', 'false');
        });
    }
    
    selectOption(index) {
        if (index < 0 || index >= this.options.length) return;
        
        const selectedOption = this.options[index];
        const optionText = selectedOption.innerText;
        const optionValue = selectedOption.dataset.value;
        
        this.selectedValueSpan.textContent = optionText;
        
        this.currentIndex = index;
        this.updateAriaSelected();
        
        this.announcer.textContent = `Выбрано: ${optionText}`;
        
        this.closeDropdown();
        
        this.button.focus();
        
        this.dispatchChangeEvent(optionValue, optionText);
    }
    
    highlightOption(index) {
        if (!this.isOpen) return;
        this.options[index].focus();
    }
    
    updateAriaSelected() {
        this.options.forEach((option, index) => {
            if (index === this.currentIndex) {
                option.setAttribute('aria-selected', 'true');
            } else {
                option.setAttribute('aria-selected', 'false');
            }
        });
    }
    
    handleButtonKeydown(e) {
        const key = e.key;
        
        switch(key) {
            case 'Enter':
            case ' ':
            case 'Space':
                e.preventDefault();
                this.toggleDropdown();
                break;
                
            case 'ArrowDown':
                e.preventDefault();
                if (!this.isOpen) {
                    this.openDropdown();
                } else {
                    this.navigateOptions('down');
                }
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                if (!this.isOpen) {
                    this.openDropdown();
                } else {
                    this.navigateOptions('up');
                }
                break;
                
            case 'Home':
                e.preventDefault();
                if (this.isOpen) {
                    this.navigateOptions('home');
                }
                break;
                
            case 'End':
                e.preventDefault();
                if (this.isOpen) {
                    this.navigateOptions('end');
                }
                break;
        }
    }
    
    handleOptionKeydown(e, index) {
        const key = e.key;
        
        switch(key) {
            case 'Enter':
            case ' ':
                e.preventDefault();
                this.selectOption(index);
                break;
                
            case 'Escape':
                e.preventDefault();
                this.closeDropdown();
                this.button.focus();
                break;
                
            case 'ArrowDown':
                e.preventDefault();
                this.navigateOptions('down');
                break;
                
            case 'ArrowUp':
                e.preventDefault();
                this.navigateOptions('up');
                break;
                
            case 'Home':
                e.preventDefault();
                this.navigateOptions('home');
                break;
                
            case 'End':
                e.preventDefault();
                this.navigateOptions('end');
                break;
                
            case 'Tab':
                this.closeDropdown();
                break;
        }
    }
    
    navigateOptions(direction) {
        if (!this.isOpen || this.options.length === 0) return;
        
        let newIndex = this.currentIndex;
        
        switch(direction) {
            case 'down':
                newIndex = (this.currentIndex + 1) % this.options.length;
                break;
                
            case 'up':
                newIndex = (this.currentIndex - 1 + this.options.length) % this.options.length;
                break;
                
            case 'home':
                newIndex = 0;
                break;
                
            case 'end':
                newIndex = this.options.length - 1;
                break;
        }
        
        this.currentIndex = newIndex;
        this.options[newIndex].focus();
        this.updateAriaSelected();
        
        this.options[newIndex].scrollIntoView({ block: 'nearest' });
    }
    
    dispatchChangeEvent(value, text) {
        const event = new CustomEvent('selectChange', {
            detail: { value, text },
            bubbles: true
        });
        this.select.dispatchEvent(event);
    }
    
    setValue(value) {
        const option = Array.from(this.options).find(opt => 
            opt.dataset.value === value
        );
        
        if (option) {
            const index = Array.from(this.options).indexOf(option);
            this.selectOption(index);
        }
    }
    
    getValue() {
        if (this.currentIndex >= 0) {
            return {
                value: this.options[this.currentIndex].dataset.value,
                text: this.options[this.currentIndex].textContent
            };
        }
        return null;
    }
    
    focus() {
        this.button.focus();
    }
}


if ( typeof ZrpCountrySelector !== 'function' ) {

    class ZrpCountrySelector extends HTMLElement {

        constructor() {
            super();

            // Use languages in current country
            this.allowLangs = {
                'AT' : ['en'],
                'AZ' : ['en', 'az'],
                'BE' : ['en'],
                'BR' : ['en', 'pt'],
                'BG' : ['en'],
                'HR' : ['en'],
                'CY' : ['en'],
                'CY' : ['en'],
                'CZ' : ['en'],
                'DK' : ['en'],
                'EE' : ['en'],
                'FI' : ['en'],
                'FR' : ['en'],
                'DE' : ['en', 'de'],
                'GR' : ['en'],
                'HU' : ['en'],
                'IN' : ['en', 'hi'],
                'IE' : ['en'],
                'IT' : ['en'],
                'LV' : ['en'],
                'LT' : ['en'],
                'LU' : ['en'],
                'MT' : ['en'],
                'NL' : ['en'],
                'PA' : ['en'],
                'PL' : ['en', 'pl'],
                'PT' : ['en'],
                'RO' : ['en'],
                'RS' : ['en'],
                'SK' : ['en'],
                'SI' : ['en'],
                'ES' : ['en'],
                'SE' : ['en'],
                'AE' : ['en', 'ar'],
                'GB' : ['en']
            }

            // Settings
            this.settings = JSON.parse(this.dataset.options);

            // State from URL
            const stateFromUrl = this.getStateFromUrl();

            if (stateFromUrl) {
                this.setStorage(stateFromUrl);                
            }

            // State
            this.state = this.getState();

            // Loading bg image
            // if (this.settings.bgImg) {
            //     this.loadBg();
            // }

            // Initialize interface
            this.init();
        }

        show() {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.classList.add('zrp-ps--show');
                });
            });
        }

        loadBg() {
            const img = new Image();
                img.onload = () => {
                this.style.backgroundImage = `url(${img.src})`;
            }
            img.src = this.settings.bgImg;
        }


        /**
         * Get site URL for transition
         */
        getSiteUrl() {

            let host;
            let path;

            const { country, language } = this.state;

            const uObj = new URL(window.location.href);
            const currentHost = uObj.host;
            const currentPath = uObj.pathname;
            
            switch (`${language}_${country}`) {
                case 'en_AE':
                    host = 'zielinskiandrozen.ae';
                    break;
                case 'ar_AE':
                    host = 'zielinskiandrozen.ae/ar';
                    break;
                case 'en_AZ':
                    host = 'zielinskiandrozen.az';
                    break;
                case 'pt_BR':
                    host = 'zielinskiandrozen.com.br';
                    break;
                case 'en_BR':
                    host = 'zielinskiandrozen.com.br/en';
                    break;
                case 'en_GB':
                    host = 'zielinskiandrozen.co.uk';
                    break;
                case 'de_DE':
                    host = 'zielinskiandrozen.com/de';
                    break;
                case 'en_PA':
                    host = 'zielinskiandrozen.com.pa';
                    break;
                case 'en_RS':
                    host = 'zielinskiandrozen.rs';
                    break;
                case 'pl_PL':
                    host = 'zielinskiandrozen.com/pl';
                    break;
                case 'en_IN':
                    host = 'zielinskiandrozen.in';
                    break;
                case 'hi_IN':
                    host = 'zielinskiandrozen.in/hi';
                    break;
                case 'ru_RU':
                    host = 'zielinskiandrozen.ru';
                    break;
                default:
                    host = 'zielinskiandrozen.com';
            }

            const hostArr = host.split('/');

            // Redirect to other domain
            if (hostArr[0].indexOf(currentHost) == -1) {
                uObj.host = hostArr[0];
                if (hostArr[1]) {
                    uObj.pathname = hostArr[1];
                }
            } else {
            
                uObj.host = hostArr[0];
                const domainLang = hostArr[1];

                if (!domainLang) {
                    uObj.pathname = currentPath.split('/').filter((val)=>{
                            if (val.length == 2) return false;
                            return true;
                    }).join('/');
                } else {
                    if (currentPath == '/') {
                        uObj.pathname = `/${domainLang}`;
                    } else {
                        if (currentPath.indexOf(domainLang) != -1) {
                            uObj.pathname = `${currentPath}`;
                        } else {
                            uObj.pathname = `/${domainLang}${currentPath}`;
                        }
                    }
                }

            }

            // Queries
            uObj.searchParams.set('country', country.toLowerCase());
            uObj.searchParams.set('language', language);
       
            return uObj.href;
           
        }

        /**
         * Get params from URL
         */
        getStateFromUrl() {
            const urlParams = new URLSearchParams(window.location.search);

            let country = urlParams.get('country');
            let language = urlParams.get('language');

            // Check country
            if (country && typeof country === 'string' && country.length === 2) {
                country = country.toUpperCase();
            } else {
                country = null;
            }
            
            // Check language
            if (language && typeof language === 'string' && language.length === 2) {
                language = language.toLowerCase();
            } else {
                language = null;
            }

            if (country !== null && language !== null) {
                return {
                    country,
                    language
                }
            }

        }

        /**
         * Get local state
         */
        getState() {
            const state = {
                country: '',
                language: '',
            }

            const store = this.getStorage();

            if (store) {
                
                if (store.country) {
                    state.country = store.country;
                }

                if (store.language) {
                    state.language = store.language;
                }

            } else {
            
                if (this.settings.defCountry) {
                    state.country = this.settings.defCountry;
                }

                if (this.settings.defLang) {
                    state.language = this.settings.defLang;
                }

            }

            return state;
        }

        /**
         * Save object to storage
         */
        setStorage(obj) {
            localStorage.setItem('zrp-ps', JSON.stringify(obj));
        }

        /**
         * Get object from storage
         */
        getStorage() {
            const store = localStorage.getItem('zrp-ps');
            if (store) {
                return JSON.parse(store);
            }
            return null;
        }

        /**
         * Get item from storage
         */
        getStorageItem(key) {
            const store = localStorage.getItem('zrp-ps');
            if (store) {
                const obj = JSON.parse(store);
                if (obj[key]) {
                    return obj[key];
                }
            }
            return null;
        }

        /**
         * Update languages
         */
        updateLangsView(id) {

            const allowLangs = this.allowLangs[this.state.country];
            const selectEl = this.querySelector(`#${id}`);
            const optionEls = selectEl && selectEl.querySelectorAll('.zrp-ps__option')

            optionEls && optionEls.forEach(optionEl => {
                const value = optionEl.dataset.value;
                if (allowLangs.includes(value)) {
                    optionEl.style.display = 'flex';
                } else {
                    optionEl.style.display = 'none';
                }
            });

            if (allowLangs.length > 0) {
                return allowLangs[0];
            }
        }

        init() {

            
            document.addEventListener('DOMContentLoaded', () => {

                // See to storage
                const store = this.getStorage();

                // Open screen
                if (!store) {
                    setTimeout(()=>{
                        this.show();
                    }, 1000);
                }

                // Trigger call
                document.body.addEventListener('click', (e)=>{
                    if (e.target.classList.contains('zrp-ps-call')) {
                        e.preventDefault();
                        this.show();
                    }
                });

                
                this.countrySelect = new ZrpSelect('zrp-country');
                this.languageSelect = new ZrpSelect('zrp-language');

                // Country select
                this.countrySelect.setValue(this.state.country);
                this.updateLangsView('zrp-language');

                this.countrySelect.select.addEventListener('selectChange', (e) => {
                    this.state.country = e.detail.value;
                    const firstLang = this.updateLangsView('zrp-language');
                    this.languageSelect.setValue(firstLang);
                });
                
                // Language select    
                this.languageSelect.setValue(this.state.language);
            
                this.languageSelect.select.addEventListener('selectChange', (e) => {
                    this.state.language = e.detail.value;
                });

                // Send button
                const btn = this.querySelector('.zrp-ps__btn-send');

                btn && btn.addEventListener('click', () => {
                    if (this.state.country && this.state.language) {
                        this.setStorage(this.state);
                        window.location.href = this.getSiteUrl();
                    }
                });

            });

        }

    }

    if ( typeof customElements.get('zrp-country-selector') == 'undefined' ) {
        customElements.define('zrp-country-selector', ZrpCountrySelector);
    }

}
